var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "blue",
    height: 35,
    viewBox: "0 -960 960 960",
    width: 45,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149-191q-26 0-44.5-18.5T86-254q0-26 18.5-44.5T149-317h662q26 0 44.5 18.5T874-254q0 26-18.5 44.5T811-191H149Zm0-226q-26 0-44.5-18.5T86-480q0-26 18.5-44.5T149-543h662q26 0 44.5 18.5T874-480q0 26-18.5 44.5T811-417H149Zm0-226q-26 0-44.5-18.5T86-706q0-26 18.5-44.5T149-769h662q26 0 44.5 18.5T874-706q0 26-18.5 44.5T811-643H149Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.39b1b1fc58b1e8123d272aa27e8a92b5.svg";
export { ForwardRef as ReactComponent };